var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-width"},_vm._l((_vm.targetCellBaseline),function(datasets,BaselineGroup){return _c('BaselineGroup',{key:BaselineGroup,attrs:{"label":BaselineGroup,"value":datasets,"unitTitle":BaselineGroup,"datasets":datasets,"targetID":_vm.targetID}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }